/* global require */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
const uuidv4 = require('uuid/v4');

class Component extends BaseComponent {
    componentDidMount() {
        this.uuid = uuidv4();
    }

    render() {
        let className = this.props.checked ? 'checked' : '';
        className = this.props.error ? `${className} has-error` : className;
        className = this.props.disabled ? `${className} disabled` : className;
        let label = this.props.ppcLabel ? this.renderPrivacyPolicyLabel() : this.renderLabel();

        return (
            <checkbox-group>
                <row className='is-aligned-center'>
                    <column className='is-1 is-2-mobile has-text-center'>
                        <label htmlFor={this.uuid}>
                            <pseudo-checkbox className={className}>
                                <span />
                                <input type='checkbox' {...this.props} id={this.uuid} />
                            </pseudo-checkbox>
                        </label>
                    </column>
                    <column className='is-11 is-10-mobile has-padding-10-left'>
                        {label}
                    </column>
                </row>
                {this.renderError()}
            </checkbox-group>
        );
    }

    renderPrivacyPolicyLabel = () => {
        /* eslint-disable max-len */
        return (
            <span>
                By continuing, you accept our <a href='/privacy-policy' target='_blank' rel='noopener' onClick={() => this.trackClick('Privacy Policy')}>Privacy Policy</a> and <a href='/terms-of-use' target='_blank' rel='noopener' onClick={() => this.trackClick('Terms of Use')}>Terms of Use</a>.
            </span>
        );
        /* eslint-enable max-len */
    }

    renderLabel = () => {
        return (
            <label htmlFor={this.uuid} dangerouslySetInnerHTML={{ __html: this.props.label }} />
        );
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <row>
                    <column className='is-1' />
                    <column className='is-11 has-padding-10-left'>
                        <p className='is-error'>{this.props.error}</p>
                    </column>
                </row>
            );
        }

        return null;
    }

    trackClick = (label) => {
        const action = 'Click';
        const category = 'Site Interaction';
        label = 'Signup: ' + label;

        this.props.trackEvent([category, action, label]);
    }
}

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);